import $ from 'jquery';

export const injectChangeClothesCanvasHtml = () => {
  $('#change-clothes-container').html(`
    <canvas id="drawing-change-clothes-canvas"></canvas>
    <canvas id="manipulation-change-clothes-canvas" style="display: none"></canvas>`);
};
